import React from 'react'
import Typography from '@material-ui/core/Typography'

export default () => (
	<Typography variant="body1" gutterBottom>
		Det finns ingen stompunkt med detta ID.
	</Typography>
)


// WEBPACK FOOTER //
// ./src/components/Stompunkt/StompunktMissing.js